module.exports = __webpack_public_path__ + "media/application/images/404-img-3-0e14c6f940d5ad3fac5a1c51d8bc284a.png";